export default __webpack_public_path__ + "static/media/delete.0ac8dd79.svg";